import {Redirect, Route, Switch, useHistory, useLocation} from "react-router";
import React, {useEffect, useMemo, useState} from "react";

import {useShallowEqualSelector} from "../hooks/useShallowSelector";
import {changeViewMode, viewModeSelector} from "../reducers/appReducer";
import {ViewMode} from "../api/dto/AppDTO";
import {Routes} from "../constants/Routes";
import AuthContainer from "./auth/AuthContainer";
import Cookies from "js-cookie"
import {AppRootContainer} from "./AppRootContainer";
import {Loader} from "../components/ui/Loader";
import {Box} from "@mui/material";
import {useQuery} from "../hooks/useQuery";
import {useDispatch} from "react-redux";


export function RootContainer() {
    const [loading, setLoading] = useState(true);
    const [token, setToken] = useState("");
    const query = useQuery();
    const location = useLocation();
    const history = useHistory();
    const dispatch = useDispatch();
    const viewMode = useShallowEqualSelector(viewModeSelector);

    useEffect(() => {
        if (query.get("jwt_token")) {
            Cookies.set("token", query.get("jwt_token") ?? "");
            dispatch(changeViewMode({ viewMode: ViewMode.Full }));
            window.open(location.pathname, "_self");
        } else {
            setToken(Cookies.get("token") ?? "");
            setLoading(false)
        }
    }, [query, token, viewMode]);

    const isAuthorized = useMemo(() => Boolean(token && viewMode !== ViewMode.Undetermined), [
        token,
        viewMode,
    ]);

    return (
        <>
            {loading ? (
                <Box sx={{
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <Loader size={50} />
                </Box>
            ) : (
                <Switch>
                    {isAuthorized && <Redirect to={Routes.IntegrationList} from="/auth"/>}
                    {isAuthorized && <Redirect exact={true} to={Routes.IntegrationList} from="/"/>}
                    {isAuthorized && <Route component={AppRootContainer}/>}

                    {!isAuthorized && <Route component={AuthContainer} path={Routes.Auth}/>}
                    {!isAuthorized && <Redirect to={Routes.AuthLogin}/>}
                </Switch>
            )}
        </>
    );
}
